import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Gitlab = ({
  className,
  width = 24,
  height = 24
}: SVGProps) => {
  return (
    <svg 
      className={className}
      width={width}
      height={height}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd"
        d="m20.9663 13.1482-1.0072-2.9912-1.9961-5.92826c-.1027-.30499-.5499-.30499-.6526 0L15.3142 10.157H8.68567L6.68944 4.22874c-.10266-.30499-.54985-.30499-.65259 0L4.04074 10.157 3.0336 13.1482c-.04479.133-.0448.2763-.00002.4093.04477.133.13203.2489.24927.331L11.9999 20l8.7171-6.1115c.1173-.0822.2045-.1981.2493-.331.0448-.133.0448-.2763 0-.4093Z" 
        fill="#FC6D26"
        />
          <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="m11.9999 20 3.3143-9.843H8.68567L11.9999 20Z" 
          fill="#E24329"
          />
            <path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="m11.9999 20-3.31423-9.843H4.04074L11.9999 20Z" 
            fill="#FC6D26"
            />
              <path 
              fillRule="evenodd" 
              clipRule="evenodd" 
              d="M4.04074 10.157 3.0336 13.1482c-.04479.133-.0448.2763-.00002.4093.04477.133.13203.2489.24927.331L11.9999 20l-7.95916-9.843Z" 
              fill="#FCA326"
              />
                <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M4.04074 10.157h4.64493L6.68944 4.22874c-.10266-.30499-.54985-.30499-.65259 0L4.04074 10.157Z" 
                fill="#E24329"
                />
              <path 
              fillRule="evenodd" 
              clipRule="evenodd" 
              d="m11.9999 20 3.3143-9.843h4.6449L11.9999 20Z" 
              fill="#FC6D26"
              />
          <path 
          fillRule="evenodd"
          clipRule="evenodd" 
          d="m19.9591 10.157 1.0072 2.9912c.0448.133.0448.2763 0 .4093-.0448.1329-.132.2488-.2493.331L11.9999 20l7.9592-9.843Z" 
          fill="#FCA326"
          />
        <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M19.9591 10.157h-4.6449l1.9962-5.92826c.1027-.30499.5499-.30499.6526 0l1.9961 5.92826Z" 
        fill="#E24329"
        />
      </svg>
  );
};
